import React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomDropdown, FilterOptionType } from 'src/components/RealityCheckForm/CustomDropdown';
import {
    SourceOfFundsRequiredMark,
    SourceOfFundsRestrictionPeriodField,
    SourceOfFundsRestrictionPeriodFieldLabel,
    SourceOfFundsRestrictionPeriodPanel,
} from 'src/components/ComplianceConfiguration/SourceOfFunds/SourceOfFunds.style';
import { SOURCE_OF_FUNDS_COMPLIANCE_RESTRICTION_OPTIONS_ARRAY } from 'src/components/ComplianceConfiguration/SourceOfFunds/SourceOfFundsThresholdOptions';

interface SourceOfFundsRestrictionPeriodDropdownPropsType {
    dataTestPrefix: string;
    value: string;
    onChange: (value: string) => void;
}

export const SourceOfFundsRestrictionPeriodDropdown = observer(
    ({ dataTestPrefix, value, onChange }: SourceOfFundsRestrictionPeriodDropdownPropsType): JSX.Element => (
        <SourceOfFundsRestrictionPeriodPanel data-test={`${dataTestPrefix}-compliance-restriction-period-panel`}>
            <SourceOfFundsRestrictionPeriodField>
                <SourceOfFundsRestrictionPeriodFieldLabel>
                    Restriction period
                    <SourceOfFundsRequiredMark> *</SourceOfFundsRequiredMark>
                </SourceOfFundsRestrictionPeriodFieldLabel>
                <CustomDropdown
                    dataTest={`${dataTestPrefix}-compliance-restriction-period`}
                    hasInternalLabel={false}
                    onChangeCallback={(selected): void => {
                        if (typeof selected === 'string') {
                            onChange(selected);
                        }
                    }}
                    optionsList={(): Array<FilterOptionType<string>> =>
                        SOURCE_OF_FUNDS_COMPLIANCE_RESTRICTION_OPTIONS_ARRAY
                    }
                    placeholder='Select period'
                    selectedValue={(): string => value}
                    useMenuPortal
                />
            </SourceOfFundsRestrictionPeriodField>
        </SourceOfFundsRestrictionPeriodPanel>
    )
);
